var timeout = false;
var rtime;
var delta = 500;
$(function(){ 
    initForm('body');
   
	$('.account-sidebar-trigger').click(function(){
        $('body').toggleClass('show-account-sidebar');
        return false;
    });  
    
    $('.account-nav-mobile-sidebar-overlay, .account-nav-mobile .close-responsive-nav').click(function(){
        $('body').removeClass('show-account-sidebar');
        return false;
    });
    if ("ontouchstart" in window || navigator.msMaxTouchPoints)
    {
        $('body').addClass('touch');
    } else {
        $('body').addClass('no-touch');
    }   
    

     $('.close-responsive-nav,.responsive-nav-overlay,.show-menu .burger-btn').click(function($e){
        $('body').removeClass('show-menu');
        $e.preventDefault();
    });
    
    $('.burger-btn').click(function($e){
        $('body').toggleClass('show-menu');
        $('.megamenu-product-link').removeClass('active-hovered').removeClass('hovered');
        $( ".brand-nav-item" ).removeClass('hovered-brand');
        $('.megamenu-product-image').hide();
        $e.preventDefault();
    });

    if($('.fixed-cta').length>0){
        var scrolled_from_top = $(document).scrollTop();
            if(scrolled_from_top > 500){
                $('.fixed-cta').addClass('cta-shown');
            }else{
                $('.fixed-cta').removeClass('cta-shown');
            }
             $(window).scroll(function(){
                var scrolled_from_top = $(document).scrollTop();        
                if(scrolled_from_top > 500){
                    $('.fixed-cta').addClass('cta-shown');
                }else{
                    $('.fixed-cta').removeClass('cta-shown');
                }
            });
    }


     $( ".megamenu-product-link" ).mouseenter(function() {
           $this =$(this),
           $active = $(this).data('target'),
           $active_link = $('.megamenu-drinks-nav .nav-item .active'),
            $active_target =  $active_link.data('target');

            if($($active).length>0){
                $active_link.addClass('active-hovered');
               if($this.hasClass('active')){
                   $this.removeClass('active-hovered');
               }

                if(!$this.hasClass('hovered') && $active_link.hasClass('active-hovered')){
                     $('.megamenu-product-image').hide();
                     $( ".brand-nav-item" ).removeClass('hovered-brand');
                }
                $( ".megamenu-product-link" ).removeClass('hovered');

                $this.addClass('hovered');

                $('.product-nav-group').hide();
                $($active).show(); 
            }
            

      });
       $( ".brand-nav-item" ).mouseenter(function() {
           $this =$(this),
           $active = $(this).data('target');
            if($($active).length>0){
                $( ".brand-nav-item" ).removeClass('hovered-brand');
                $this.addClass('hovered-brand');
                $('.megamenu-product-image').hide();
                $($active).show();
            }
      });


     
     if($(window).scrollTop() > 50) {
          $('body').addClass('scrolled');  
    }
    
     var lastScrollTop = 0;
     $(document).on('scroll',function() {

        _scrollTop = $(window).scrollTop();
        if (_scrollTop >= 50) {
            $('body').addClass('scrolled');  
        } else {
            $('body').removeClass('scrolled');
        }
    });


    $('.go-to-anchor').click(function(){
        var anchor = $(this).attr('href');
        $('html, body').stop().animate({scrollTop: $(anchor).offset().top}, 'slow');
        return false;
    });    
}); 

function initForm(target){
	'use strict';


	$('.select2,select[data-plg="select2"]:visible').each(function(){
		var data = $(this).data();
	    var options = {};
	    if(data.ajax){
	        options = $.extend(false, options ,{
	            placeholder: data.placeholder,
	            allowClear: data.allowClear || false,
	            ajax: {
	                url : API + '/'+ data.ajax,
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    var search_for = typeof(params.term)!=='undefined'?params.term:'';
	                    return {
	                        q: data.search+'=@'+search_for,
	                        page: params.page
	                    };
	                },
	                processResults: function (res, params) {
	                    params.page = params.page || 1;
	                    var value_field = data.value || 'id';
	                    var label_field = data.label || data.search;
	                    return {
	                        results:  $.map(res.data, function (item) {
	                            return { 
	                                all_data: item,
	                                text: item[label_field],
	                                id: item[value_field]
	                            }
	                        }),
	                        pagination: {
	                            more: (params.page * 30) < data.total_count
	                        }
	                    };
	                },
	                cache: true
	            },
	            minimumInputLength: 0
	        });
	    }
	    $(this).select2(options);
	});

    if($(target + ' [data-plg="tags"]').length > 0){
        $(target + ' [data-plg="tags"]').each(function(){
            $(this).select2({
                tags: true,
                tokenSeparators: ['/',',',';'," "]
            });
        });
    }
	if($(target + ' [data-toggle="collapse"]').length > 0){
        $(target + ' [data-toggle="collapse"]').on('click',function(){
            var href = $(this).attr('href');
            setTimeout(function(){
                initForm(href);
            },1);
        });
    }
    $('[data-toggle="tooltip"]').tooltip();



    $(target + ' input[data-plg="datepicker"]').each(function(){

        var configuration = $(this).data();
		configuration.autoUpdateInput = false;
        configuration.singleDatePicker = true;
		configuration.locale = { format : 'MM.DD.YYYY' };
        $(this).datepicker(configuration);

		$(this).on('apply.datepicker', function(ev, picker) {
            $(this).val(picker.startDate.format('MM.DD.YYYY'));
			$(this).trigger('change');
	  	});

		$(this).on('cancel.datepicker', function(ev, picker) {
		  	$(this).val('');
			$(this).trigger('change');
		});
    });

}

 
var AjaxForms = {

    options : {
        target        : null,
        stop_response : false,
        empty_form 	  : true,
        successFn     : null,
        errorFn       : null,
        method        : 'POST',
        recaptcha     : false
    },
    
    init:function(t){
        var $this = this;

        if($this.recaptcha ===  true){
            $.ajax({
                url: 'https://www.google.com/recaptcha/api.js',
                dataType: "script",
                success:function(){
                    try{
                        grecaptcha.execute();
                    }catch (Error){}
                }
            });
        }

        $this.options.target = t;

        $($this.options.target).parsley({
			excluded: "textarea:hidden, input:hidden, select:hidden"
		});
        $($this.options.target).on('submit',function($e){

            $this.submit_form();
            $e.preventDefault(); 

        }).addClass('ready');
    },
    form_submit_response : function( msg , type){
        actionResponseModal(msg,type);
    },
    submit_form:function(){

        var $this       = this,
            $form       = $($this.options.target),
            successFn   = $this.options.successFn,
            errorFn     = $this.options.errorFn,
            url         = $form.attr('action'),
            postData    = $form.serialize(),
            method      = $form.attr('method'),
            $submitBTN  = $form.find('button[type="submit"]');

		if(!$submitBTN.hasClass('like-btn')){
			
			$submitBTN.prop('disabled',true);
			$submitBTN.data('initialText',$submitBTN.text());
			$submitBTN.html('<i class="fa fa-spinner fa-spin"></i> '+ ['working on it']);
			$submitBTN.hide(); 			
		}
		
		
        $.ajax({
            url     : url,
            data    : postData,
            type    : method,
            success: function (data) {			
				
                if($this.recaptcha ===  true){
                    grecaptcha.execute();
                    grecaptcha.reset();
                }
				
				if(!$submitBTN.hasClass('like-btn')){
					if(data.message){
						$submitBTN.text(data.message);
					}else{
						$submitBTN.html($submitBTN.data('initialText'));
					}	
				}               
				if($this.options.empty_form){
					$form.find('input,textarea,select').not(':hidden').each(function(){
	                    $(this).val('');
	                    $(this).removeClass('parsley-success');
	                });	
				} 

                if(typeof(successFn) !== 'undefined'){
                    successFn(data);
                }                
                if(!$this.options.stop_response){
                	$this.form_submit_response( data.message || 'submitted', 'success');		
                }
            },
            error: function (response) {
                if($this.recaptcha ===  true){
                    grecaptcha.execute();
                    grecaptcha.reset();
                }
                $submitBTN.prop('disabled',false);	
                var responseJSON = jQuery.parseJSON(response.responseText);
                if(errorFn !== null){
                    errorFn( responseJSON );
                }else{
                    for(var i in responseJSON){
                        var t = $form.find('input[name="'+i+'"]').closest('.form-group');
                        
                        t.find('input').addClass('parsley-error');

                        if(t.find('.parsley-errors-list').length > 0){
                            t.find('.parsley-errors-list').html('<li class="parsley-type">'+responseJSON[i].join('')+'</li>');
                        }else{
                            t.append('<ul class="parsley-errors-list filled"><li class="parsley-type">'+responseJSON[i].join('')+'</li></ul>');    
                        }
                    }
                    $this.form_submit_response( data.message || 'error', 'error');
                }
            }
        });
    } 
}
 

function actionResponseModal(msg, type, container){
	var $timeout = 0;
	
	if($('body').hasClass('modal-open') ){
		$('.modal').modal('hide');
		$timeout = 500;	
	}
	setTimeout(function(){
		var _container = container || '';
		if(type == 'success'){
			var icon = '<i class="fa fa-check-circle" aria-hidden="true"></i>';	
		}else{
			var icon = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i>';	
		}
		var content = '<div class="alert alert-'+type+'"><h3>'+msg+'</h3></div>'
		$('#responseModal .modal-body').html(content);	
		$('body').addClass('dark-backdrop');
		$('#responseModal').modal('show');
		$('#responseModal').on('hidden.bs.modal', function () {
			$('#responseModal .modal-body').empty();
			$('body').removeClass('dark-backdrop');
		});
	},$timeout);
}



function countnumber(end, $target ,duration){
	"use strict";	
	$target.each(function(){
		var $this = $(this);
		$this.prop('Counter', parseInt($this.data('value')) ).animate(
			{
				Counter: parseInt(end)
			}, 
			{
				duration: duration,
				easing: 'swing',
				step: function (now) {
					$(this).text(Math.ceil(parseInt(now)).toLocaleString());
				},
				complete: function() {
					/*$this.parent().addClass('blink');	
					setTimeout(function(){
						$this.parent().removeClass('blink');		
					},500);*/					
				}
			}
	 	);
	});		
}

function lrs_tracking(tracking_type,tracking_data){
	
}

// https://stackoverflow.com/questions/1458724/how-do-i-set-unset-a-cookie-with-jquery
function createCookie(name, value, hours) {
    var expires;

    if (hours) {
        var date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}


function getScripts( scripts, onScript, onComplete )
{
    this.async = true;
    this.cache = false;
    this.data = null;
    this.complete = function () { $.scriptHandler.loaded(); };
    this.scripts = scripts;
    this.onScript = onScript;
    this.onComplete = onComplete;
    this.total = scripts.length;
    this.progress = 0;
};

getScripts.prototype.fetch = function() {
    $.scriptHandler = this;
    var src = this.scripts[ this.progress ];
    console.log('%cFetching %s','color:#ffbc2e;', src);

    $.ajax({
        crossDomain:true,
        async:this.async,
        cache:this.cache,
        type:'GET',
        url: src,
        data:this.data,
        statusCode: {
            200: this.complete
        },
        dataType:'script'
    });
};

getScripts.prototype.loaded = function () {
    this.progress++;
    if( this.progress >= this.total ) {
        if(this.onComplete) this.onComplete();
    } else {
        this.fetch();
    };
    if(this.onScript) this.onScript();
};
